module.exports = __webpack_public_path__ + "img/icon-monitor.b16de74a.svg";